import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import { LeadStatus } from "@/v2/enums/LeadStatus";
  import { getLeadStatusClass } from "@/v2/helpers/lead-status";

  interface Props {
    isOpen: boolean;
    selectedCount: number;
  }

  interface Emits {
    (e: "close"): void;
    (e: "confirm", status: LeadStatus): void;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkStatusModal',
  props: {
    isOpen: { type: Boolean },
    selectedCount: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const selectedStatus = ref<LeadStatus | "">("");

  const selectStatus = (status: LeadStatus) => {
    selectedStatus.value = status;
  };

  const confirmStatus = () => {
    if (selectedStatus.value) {
      emit("confirm", selectedStatus.value);
    }
  };

  const closeModal = () => {
    selectedStatus.value = "";
    emit("close");
  };

  // Reset selected status when modal opens/closes
  watch(
    () => props.isOpen,
    (isOpen) => {
      if (!isOpen) {
        selectedStatus.value = "";
      }
    }
  );

const __returned__ = { props, emit, selectedStatus, selectStatus, confirmStatus, closeModal, ref, watch, get LeadStatus() { return LeadStatus }, get getLeadStatusClass() { return getLeadStatusClass } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})